// @flow
import React, { useContext } from "react";
import { MultiSelectionContext } from "data/context";
import Icons from "@hs/icons";
import { BrowserDragLink } from "components/ItemUriLink";
import ValueFactory from "components/Attributes/SummaryAttribute/ValueFactory";
import Mark from "@hs/mark";
import {
    GridListConstant,
    SearchValueType,
    SummaryAttributeValueType,
} from "data/types";
import withStickyToggle from "containers/StickyToggle";
import StickyToggleStyle from "containers/StickyToggle/style";
import { isHandheld } from "data/bowser";
import styles from "./CellContent.module.css";

const style = {
    marginLeft: ".5em",
    verticalAlign: "middle",
};

type Props = {
    col: DocColumnResultDTO,
    cell: any,
    filterText: any,
    onMoreClick: (
        e: SyntheticMouseEvent,
        itemUri: string,
        index: number
    ) => void,
    actionsDisabled: boolean,
    itemUri: string,
};

export const CellContent = ({ index, cell, col, isHovered }: Props) => {
    /* istanbul ignore next */
    const { multiple, renderCheckbox } = useContext(MultiSelectionContext) || {
        multiple: false,
        renderCheckbox: () => null,
    };
    let content = cell && cell.value;
    if (col.name === GridListConstant.ExtensionIcon) {
        if (multiple && isHandheld()) {
            content = renderCheckbox(index, styles.checkbox);
        } else {
            content = (
                <>
                    {(isHovered || multiple) &&
                        !isHandheld() &&
                        renderCheckbox(
                            index,
                            `${styles.checkbox} ${styles.desktop}`
                        )}
                    {cell.isDoc ? (
                        <BrowserDragLink
                            itemUri={cell.itemUri}
                            className={`${styles.link}${
                                isHandheld() ? "" : ` ${styles.desktop}`
                            }`}
                        >
                            <Icons.FileExt ext={cell.ext} style={style} />
                        </BrowserDragLink>
                    ) : (
                        <Icons.ElementType
                            elementType={cell.elementType}
                            style={style}
                            className={`${styles.link}${
                                isHandheld() ? "" : ` ${styles.desktop}`
                            }`}
                        />
                    )}
                </>
            );
        }
    } else if (SearchValueType[col.type] === SearchValueType.Link) {
        return (
            <ValueFactory
                value={content || { $type: SummaryAttributeValueType.TextLink }}
                useDefaultStyles={true}
            />
        );
    } else if (content == null) {
        return null;
    } else if (Object.prototype.hasOwnProperty.call(content, "$type")) {
        return <ValueFactory value={content} useDefaultStyles={true} />;
    }
    return (
        <Mark
            containerClassName={styles.mark}
            word={cell.foundTerms.map((term) => term.replace("*", ""))}
        >
            {content}
        </Mark>
    );
};

const CellContentWithStickyToggle = withStickyToggle({
    getStyle: StickyToggleStyle.GridList,
    renderDiv: true,
    portalTargetSelector:
        "#searchResult .ReactVirtualized__Grid__innerScrollContainer",
})(CellContent);

export default CellContentWithStickyToggle;
